module.exports = __webpack_public_path__ + "img/Menu-09.2c309885.png";